module.exports = __webpack_public_path__ + "img/img_gfx@2x.cb18bc5a.png";